import { useSessionAuth } from '@/context/Auth';
import { createRating } from '@/infrastructure/api/rating';
import { useMutation } from '@tanstack/react-query';

export interface CreateRatingPayload {
  marketId: string;
  productId: string;
  variantId: string;
  rating: number;
  comment?: string;
  attachments?: string[];
  productSnapshot: {
    quantity: number;
    sellingUnit: string;
  };
}

export const useCreateRating = () => {
  const { token } = useSessionAuth();

  return useMutation({
    mutationFn: (payload: CreateRatingPayload) => createRating(token!, payload),
  });
};
